import dateFunc from "@/utils/dateLib/dateFunc";

export default (context, inject) => {
  inject("dateFunc", (input, inputFormat) => {
    return dateFunc(input, inputFormat);
  });
};
